import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { InsertSmartLockClosingCodeResData } from "./InsertSmartLockClosingCodeResData";

const ENDPOINT = "/otc/smartlock/closingcode";

export class InsertSmartLockClosingCodeCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: InsertSmartLockClosingCodeReqData;

    constructor(installationName: string, serialNumber: string, nonce: string) {
        super();
        this.payload = new InsertSmartLockClosingCodeReqData(installationName, serialNumber, nonce);
    }

    public async execute(): Promise<InsertSmartLockClosingCodeResData> {
        let res = await this.executeCommand(this.payload);
        return new InsertSmartLockClosingCodeResData(res);
    }
}

export class InsertSmartLockClosingCodeReqData {
    installationName: string;
    serialNumber: string;
    nonce: string;

    constructor(installationName: string, serialNumber: string, nonce: string) {
        this.installationName = installationName;
        this.serialNumber = serialNumber;
        this.nonce = nonce;
    }
}
